import http from '@/utils/http';

import { normalizeNewFeatureItem } from '@home/utils/urlCollectionData';

import type { IFetchNewFeaturesParams, IFetchNewFeaturesResponse } from '@home/types/urlCollection';

export const fetchNewFeatures = (params: IFetchNewFeaturesParams): Promise<IFetchNewFeaturesResponse> => {
  return http({
    url: '/api/v1/intelligence_pc/new_features/query',
    method: 'post',
    errorHandler: true,
    data: params,
    formatData: (data: any) => {
      const features = Array.isArray(data?.features) ? data.features : [];

      return {
        features: features.map(normalizeNewFeatureItem),
      };
    },
  }) as Promise<IFetchNewFeaturesResponse>;
};
